'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingScreen = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _reactTransitionGroup = require('react-transition-group');

var _ = require('../../');

var _LoadingScreen = require('./LoadingScreen.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingScreen = exports.LoadingScreen = function LoadingScreen(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      loadingMessage = _ref.loadingMessage;
  return _react2.default.createElement(
    'div',
    { className: className + ' loadingWrapper' },
    _react2.default.createElement(
      _reactTransitionGroup.TransitionGroup,
      null,
      isLoading && _react2.default.createElement(
        _reactTransitionGroup.CSSTransition,
        {
          timeout: 1000,
          classNames: 'fade-out' },
        _react2.default.createElement(
          'div',
          { className: 'inner' },
          _react2.default.createElement(
            'div',
            { className: 'loading' },
            _react2.default.createElement(
              'div',
              { className: 'spinner' },
              _react2.default.createElement(_.Spinner, null)
            ),
            loadingMessage && _react2.default.createElement(
              'h2',
              null,
              loadingMessage
            )
          )
        )
      )
    )
  );
};

LoadingScreen.propTypes = {
  /**
   * The className provided by glamorous, it makes the magic happen.
   * Integral to the glamorous library, which this library is built upon.
   */
  className: _propTypes2.default.string,
  /**
   * Boolean flag for whether the loading screen renders
   */
  isLoading: _propTypes2.default.bool.isRequired,
  /**
   * Message to display while the user is waiting
   */
  loadingMessage: _propTypes2.default.string
};

exports.default = (0, _glamorous2.default)(LoadingScreen)(_LoadingScreen.defaultStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/LoadingScreen/LoadingScreen.js
// module id = 555
// module chunks = 0